module.exports = require('./lib/noGetters');



//////////////////
// WEBPACK FOOTER
// ./~/react-lazy-cache/noGetters.js
// module id = 405
// module chunks = 7